import { get } from 'lodash';
import { formatDate } from '../utils/dateUtils';
import { apiDateFormat, TYPE_IFT, TYPE_CHAPS, fxRatesType } from '../config';
import { CONST_INSTRUCTED } from '../constants/Constants';

const getAmountToSend = ({ amount, currency }) => ({
	amount: {
		value: amount,
		currency,
	},
});

export const getInstructedAmount = (payment) =>
	get(payment, 'payment_amount', []).find((amount) => amount.type === CONST_INSTRUCTED) || {};

export const getPreBookedRate = (payment) => {
	const isPreBooked = get(payment, 'indicative_fx.type') === fxRatesType.PRE_BOOKED_RATE;
	if (isPreBooked) {
		return {
			pre_booked: {
				reference: get(payment, 'deal_reference', ''),
				rate: get(payment, 'indicative_fx.rate', ''),
			},
		};
	}
	return {};
};

export const getExchangeRateIFTRequest = (payment) => {
	const instructedAmount = getInstructedAmount(payment);
	const { to_account: { account_holder, ...beneficiary } = {} } = payment;
	return JSON.stringify({
		payment_type: TYPE_IFT,
		indicative: !payment.final_approval,
		payments: [
			{
				source_id: payment.id,
				debit_account: get(payment, 'from_account.account_uuid'),
				debit_account_currency: payment.debtor_currency,
				send_currency: payment.creditor_currency,
				payment_date: formatDate(payment.value_date, apiDateFormat),
				charging_model: payment.charging_model,
				urgent: payment.urgent,
				beneficiary,
				payment_instruction_id: payment.payment_instruction_id,
				...getAmountToSend({
					...instructedAmount,
					amount: instructedAmount.value,
				}),
				...getPreBookedRate(payment),
			},
		],
	});
};

export const getExchangeRateRequest = (payment) => {
	const { to_account: { account_uuid, account_holder, ...beneficiary } = {} } = payment;
	return JSON.stringify({
		indicative: !payment.final_approval,
		payment_type: TYPE_CHAPS,
		payments: [
			{
				source_id: payment.id,
				debit_account: get(payment, 'from_account.account_uuid'),
				charging_model: 'DEBT',
				debit_account_currency: payment.currency,
				send_currency: payment.currency,
				payment_date: formatDate(payment.value_date, apiDateFormat),
				urgent: true,
				beneficiary,
				payment_instruction_id: payment.payment_instruction_id,
				...getAmountToSend(payment),
			},
		],
	});
};
